import { render } from "./vhpSelect.vue?vue&type=template&id=4a107e04"
import script from "./vhpSelect.vue?vue&type=script&lang=js"
export * from "./vhpSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__